var $e6bbfd79044289f2$exports = {};
$e6bbfd79044289f2$exports = {
    "loading": `Chargement...`,
    "placeholder": `S\xe9lectionner\u{2026}`
};


export {$e6bbfd79044289f2$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
